class PDFController {
    constructor(instance) {
        this.instance = instance;
        this.modal = $(this.instance.iframeWindow.frameElement).parents('.pdf-modal');

        this.modal.find('.zoom-in').on('click', () => {
            this.instance.setZoomLevel(this.instance.getZoomLevel() + 0.25);
        });
        this.modal.find('.zoom-out').on('click', () => {
            this.instance.setZoomLevel(this.instance.getZoomLevel() - 0.25);
        });
        this.modal.find('.previous-page').on('click', () => {
            this.instance.setCurrentPageNumber(this.instance.getCurrentPageNumber() - 1);
        });
        this.modal.find('.next-page').on('click', () => {
            this.instance.setCurrentPageNumber(this.instance.getCurrentPageNumber() + 1);
        });

        this.currentZoom = this.modal.find('.current-zoom');
        this.instance.Core.documentViewer.addEventListener('zoomUpdated', (e) => {
            this.currentZoom.val(e * 100);
        });
        this.currentZoom.on('input', () => {
            this.instance.setZoomLevel(this.currentZoom.val() / 100);
        });

        this.currentPage = this.modal.find('.current-page');
        this.instance.Core.documentViewer.addEventListener('pageNumberUpdated', (e) => {
            this.currentPage.val(e);
        });
        this.currentPage.on('input', () => {
            this.instance.setCurrentPageNumber(this.currentPage.val());
        });

        this.instance.addEventListener('documentLoaded', (e) => {
            this.modal.find('.max-page').text(this.instance.getPageCount());
            this.currentZoom.val(this.instance.UI.getZoomLevel() * 100);
        });
    }
}

export {PDFController};